(($) => {
	"use strict";
	
	function init() {
		$('.reminder-add-btn').on('click', addReminder);
		$('.reminder-delete-btn').on('click', deleteReminder);
		
		$(document).on('select2:select','[name="rRecurrence"]', (e)=>{onRecurrenceChange(e);});
		$(document).on('select2:select','[name="reminder-recurrence"]', (e)=>{onRecurrenceChange(e);});
		$('#checklist-form-reminder-setting-box-day-of-year-if-deficiencies, #checklist-form-reminder-setting-box-day-of-year').on("change", onDayOfYearInputChange);

		setupDatepickersGen($('.new-added-divs'));
		setupDatepickers($('.reminder:not(.reminder_template)'));
	}

	function addReminder({currentTarget}) {
		let $t = $(currentTarget);
		let $ctn = $t.closest('.reminders');
		let $clone = $ctn.find('.reminder_template').clone(true, true);
		let $ids = $clone.find('[id]');
		let $fors = $clone.find('[for]');
		let $checkboxes = $clone.find('[type="checkbox"]');
		let $radios = $clone.find('[type="radio"]');
		
		let randomId = Math.floor(Math.random() * 100000) + $ctn.children().length;

		$clone.removeClass('reminder_template js-form-ignore-as-child');
		$clone.find('select, input[type="text"]').val('');

		window.parent.updateHiddenSelect2($clone);

		$ids.each((i, el) => {
			el.id = `${el.id}-${randomId}`;
		});
		$fors.each((i, el) => {
			el.setAttribute("for", `${el.getAttribute("for")}-${randomId}`);
		});
		$checkboxes.each((i, el) => {
			el.name = `${el.name}-${randomId}`;
		});
		$checkboxes.prop('checked', false);
		$radios.each((i, el) => {
			el.name = `${el.name}-${randomId}`;
		});
		$radios.prop('checked', false);
		$radios.eq(0).prop('checked', true);
		$clone.insertBefore($t);
		setupDatepickers($clone);
	}
	
	function deleteReminder({currentTarget}) {
		$(currentTarget).closest('.reminder').remove();
	}
	
	function onRecurrenceChange(e) {
		var input = $(e.currentTarget);
		var ctn = input.closest('.reminder');
		
		$('.for-reminder', ctn).addClass("sb-d-nonei").removeClass("sb-d-blocki");
		$('.for-reminder .form-input', ctn).removeClass('required');
		$(`.for-reminder_${input.find(":selected").val()}`, ctn).addClass("sb-d-blocki").removeClass("sb-d-nonei");;
		$(`.for-reminder_${input.find(":selected").val()} .form-input`, ctn).addClass('required');
	}

	function onDayOfYearInputChange({ currentTarget }) {
		var input = $(currentTarget);
		var newVal = input.val();
		input.val(newVal.substr(newVal.indexOf("-") + 1));
	}
	
	function setupDatepickers($ctn) {
		setupDatepickersGen($ctn,"yyyy/mm/dd")
	}

	function setupDatepickersGen($ctn,longDateFormat) {
		$ctn.find('.input_day-of-year').each((i, el) => {
			$(el).datepicker({
				language: "en",
				dateFormat: "mm/dd",
				onSelect: (formattedDate, date, inst) => {
					$(el).trigger("change");
				}
			});
		});

		$ctn.find('.input_start-date').each((i, el) => {
			$(el).datepicker({
				language: "en",
				dateFormat: longDateFormat,
				timeFormat: "hh:ii aa",
				onSelect: (formattedDate, date, inst) => {
					$(el).trigger("change");
				}
			});
		});
	}

	$(init);
	
})(jQuery);